import { Injectable } from '@angular/core'
import { fromEvent, merge, Observable } from 'rxjs'
import { map, startWith } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class OnlineStatusService {
  readonly isOnline$: Observable<boolean> = merge(
    fromEvent(window, 'online').pipe(map(() => true)),
    fromEvent(window, 'offline').pipe(map(() => false)),
  ).pipe(startWith(navigator.onLine))

  get isOnline(): boolean {
    return navigator.onLine
  }
}
